module.exports = __webpack_public_path__ + "static/media/model-navara-85-4wd.5392d2b0.jpg";